import { FaGithub, FaLinkedin, FaEnvelope } from "react-icons/fa";

const SocialMedia = () => {
  return (
    <div className="flex space-x-2 items-center">
      <a href="https://github.com/limkcreply" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-black transition">
        <FaGithub size={15} />
      </a>
      <a href="https://x.com/limkaic" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-black transition">
        <img
          src="/thirdparty/X_logo.svg"
          alt="X Logo"
          width="15"
          height="15"
          className="grayscale opacity-50 hover:opacity-100 hover:grayscale-0 transition duration-300"
        />
      </a>
      <a href="https://www.linkedin.com/in/kai-lim-b1967a355/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-blue-700 transition">
        <FaLinkedin size={15} />
      </a>
      <a href="mailto:contact@limkc.com" className="text-gray-500 hover:text-red-500 transition">
        <FaEnvelope size={15} />
      </a>
    </div>
  );
};

export default SocialMedia;
